import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import PromoterList from "./PromoterList";
import { ModalPickerProps } from "../props";
import RemovablePromoter from "components/Removables/RemovablePromoter";
import { toCompanySmall } from "shared/utils/companyUtils";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import { AfterCreateAction } from "components/SidePanel/types";

type Props = Omit<ModalPickerProps<server.dto.CompanySmall>, "canCreateNew"> & (
  | { canCreateNew: false; afterCreate?: AfterCreateAction }
  | { canCreateNew: boolean; afterCreate: AfterCreateAction }
);

const PromoterModalPicker = (props: Props) => {
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();
  const onChange = (value: server.dto.CompanySmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => openNewCompanySidePanel({
        type: "promoter",
        disablePromoter: true,
        onCreated: (c) => onChange(toCompanySmall(c)),
        afterCreate: props.afterCreate ?? "closeSidebar"
      })}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.promoter.plural}
      modalSize="tiny"
      renderModalContent={(closeModal) => <PromoterList
        onItemSelected={(promoter) => {
          closeModal();
          onChange(promoter);
        }}
      />}
      renderRemovable={(props) => <RemovablePromoter {...props} layout="singleLine" />}

      {...props}
    />
  </>;
};

export default PromoterModalPicker;